<template>
  <div class>
    <div class="ShipSchedule_box">
      <el-row>
        <el-col :span="24" style="margin-top: 15px;">
          <div class="ship-shadow ship-radius ship-list-bg">
            <el-row>
              <el-col
                :span="2"
                style="text-align: left;font-size: 15px; padding-left:30px; width:100px;border-top: 1px solid #EAEAEA;border-left: 1px solid #EAEAEA;"
              >起运港：</el-col>
              <div
                :class="hidden1==0 ? 'ant-tooltip-hidden':''"
                class="ant-tooltip product-service-tooltip"
                style="left: 28px;top: 46px;transform-origin: 0px -4px;"
              >
                <div class="ant-tooltip-content">
                  <div class="ant-tooltip-arrow"></div>
                  <div class="ant-tooltip-inner">请输入起运港</div>
                </div>
              </div>
              <el-col :span="8" style="border-top: 1px solid #EAEAEA;">
                <el-select
                  class="home-port1"
                  v-model="startPortCode"
                  filterable
                  clearable
                  remote
                  default-first-option
                  placeholder="请输入起运港"
                  :remote-method="remoteStart"
                  @focus="getFocus('start')"
                  @change="getHandeleStart"
                >
                  <el-option
                    v-for="(item,index) in startPortList"
                    :key="index"
                    :label="item.portEn"
                    :value="item.portCode"
                  >
                    <span style="float: left;font-size: 12px;">{{ item.portEn }}</span>
                    <span style="float: right;font-size: 12px;margin-left: 10px;">{{ item.portCn }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col
                :span="3"
                style="text-align: left;font-size: 15px; padding-left:30px; width:100px;border-top: 1px solid #EAEAEA;"
              >目的港：</el-col>
              <div
                :class="hidden2==0 ? 'ant-tooltip-hidden':''"
                class="ant-tooltip product-service-tooltip"
                style="left: 530px;top: 46px;transform-origin: 0px -4px;"
              >
                <div class="ant-tooltip-content">
                  <div class="ant-tooltip-arrow"></div>
                  <div class="ant-tooltip-inner">请输入起运港</div>
                </div>
              </div>
              <el-col :span="8" style="border-top: 1px solid #EAEAEA;">
                <el-select
                  class="home-port1"
                  v-model="reachPortCode"
                  filterable
                  clearable
                  remote
                  default-first-option
                  placeholder="请输入目的港"
                  :remote-method="remoteReach"
                  @focus="getFocus('reach')"
                  @change="getHandeleReach"
                >
                  <el-option
                    v-for="(item,index) in reachPortList"
                    :key="index"
                    :label="item.portEn"
                    :value="item.portCode"
                  >
                    <span style="float: left;font-size: 12px;">{{ item.portEn }}</span>
                    <span style="float: right;font-size: 12px;margin-left: 10px;">{{ item.portCn }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-button
                  class="ship-button"
                  icon="el-icon-search"
                  style="width: 100%;"
                  @click="queryShipDate"
                >船期查询</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="history">
            <el-row v-if="this.historys == 1">
              <el-col :span="2" style="margin-left: 5px; width:61px;">
                <div class="grid-content bg-purple">历史查询:</div>
              </el-col>
              <el-col :span="22" style="width:1134px;">
                <li
                  :span="3"
                  v-for="(item,index) in HistoryForm"
                  style="width:160.5px;float: left;"
                >
                  <el-tooltip placement="bottom" effect="dark">
                    <div
                      class="history_item"
                      @click="historyClick(item)"
                    >{{item.polName}}-{{item.podName}}</div>
                    <div
                      slot="content"
                      style="height: 10px;line-height: 10px;"
                    >{{item.polName}}-{{item.podName}}</div>
                  </el-tooltip>
                </li>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col
          :span="6"
          style="background-color: #fff;margin: 0px 15px 10px 0px;padding: 10px;box-shadow: 0px 1px 3px #888888;border: 1px solid #EAEAEA;"
        >
          <div class>
            <div class style="text-align:left;height: 120px;border-bottom: 1px solid #eaeaea;">
              <div
                class
                style="padding: 20px 0 20px 0;font-family: 'SourceHanSans-Medium';"
              >丨直达 / 中转</div>
              <div class style=" padding-left: 20px;">
                <el-checkbox-group v-model="reachChecked" @change="reachModeChange">
                  <el-col
                    :span="12"
                    v-for="(reach,index) in reachMode"
                    :key="index"
                    style="padding: 12px 5px;"
                  >
                    <el-checkbox :label="reach" class="checkox_item"></el-checkbox>
                  </el-col>
                </el-checkbox-group>
              </div>
            </div>
            <div class style="text-align:left;">
              <div class style="padding: 20px 0 20px 0;font-family: 'SourceHanSans-Medium';">丨航运公司</div>
              <div class style="padding-left: 20px;">
                <el-checkbox-group v-model="shipChecked" @change="checkShip">
                  <el-col
                    :span="12"
                    v-for="(ship,index) in shipCompany"
                    :key="index"
                    style="padding: 12px 5px;"
                  >
                    <el-checkbox :label="ship" class="checkox_item"></el-checkbox>
                  </el-col>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="17" style="width: 885px;">
          <div
            class="ship-shadow ship-radius1"
            style="background-color: #fff;border: 1px solid #EAEAEA;"
          >
            <el-row>
              <el-col :span="2" style="padding: 8px 0;">
                <el-button
                  class="ssd_an"
                  icon="el-icon-arrow-left"
                  style="border: hidden;"
                  @click="minusSeven(dateArray[0].mark)"
                  :disabled="leftBtn"
                ></el-button>
              </el-col>
              <el-col :span="18">
                <el-row>
                  <el-col
                    class="gaoL"
                    style="width: 14.28%;text-align: center;padding: 16px 0;font-size: 14px; cursor:pointer; color: #1B1464;"
                    v-for="(item,index) in dateArray"
                    :class="item.fullYear==horizonCheckDate?'ship-border':''"
                    @click.native="checkEtd(item)"
                    :key="index"
                  >{{item.yueRi}}{{item.weekDay}}</el-col>
                </el-row>
              </el-col>
              <el-col :span="2" style="padding: 8px 0;">
                <el-button
                  class="ssd_an"
                  icon="el-icon-arrow-right"
                  style="border: hidden;"
                  @click="plusSeven(dateArray[6].mark)"
                  :disabled="rightBtn"
                ></el-button>
              </el-col>
              <el-col class="gaoL2" :span="2" style="padding:8px 0; cursor:pointer;color: #1B1464;">
                <div class @click="openCalendar(dateArray[0].yueRi)">
                  <div class="el-icon-date" style=" color:#00418E"></div>
                  <div class style="color: #1B1464;font-size: 12px;">更多日期</div>
                </div>
              </el-col>
            </el-row>
            <el-dialog
              title="船期日历"
              :visible.sync="dialogTableVisible"
              style="text-align: left; "
              class="sh-calendar"
            >
              <div class style="padding-bottom: 12px;">
                <el-row>
                  <el-col :span="selectDate.length==2?18:21">
                    <div class="sh_present">
                      当前船期：
                      <span class="sh_present2">{{shipDate}}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <el-row>
                <el-col
                  class="table-head"
                  v-for="(title,index) in ['周日','周一','周二','周三','周四','周五','周六']"
                  :key="index"
                >{{title}}</el-col>
              </el-row>
              <el-row>
                <el-col
                  class="table-line gaoL"
                  v-for="(item,index) in divideDate1"
                  :key="index"
                  @click.native="checkEtd(item)"
                  :class="[{'grey-bg':!item.yueRi},{'ship-pointer':!item.yueRi}]"
                >
                  <div class="Cl_hl" style="padding: 21px 0;">
                    {{item.yueRi}}
                    <div></div>
                  </div>
                </el-col>
              </el-row>
              <div class="sh_registration">
                注：数据更新时间为
                <span>{{dataws.ye}}</span>
              </div>
            </el-dialog>
          </div>
          <el-header class="sh_header">
            <ul class="sh_fye">
              <li class="bill_ye sh_ye1">船公司</li>
              <li class="bill_ye sh_ye2">起运港/目的港</li>
              <li class="bill_ye sh_ye3">航程</li>
              <li class="bill_ye sh_ye4">抵达目的港时间</li>
            </ul>
          </el-header>
          <el-main class="sh_main2" v-if="sh_information == 0" v-loading="loading">
            <img src="../assets/img/sail.png" class="sh_sail" alt />
            <div class="sh_noData">暂无船期数据</div>
          </el-main>
          <el-main class="sh_main" v-if="sh_information == 1">
            <ul class="sh_main_ul" v-for="(item,index) in shipList.content">
              <li class="sh_item_box">
                <el-row>
                  <el-col :span="6" style="width: 150px;padding-left: 40px;">
                    <div class="grid-content bg-purple orderTwo_content9">
                      <div class="sh_item sh_item2">{{item.carriercd}}</div>
                    </div>
                  </el-col>
                  <el-col :span="6" style="width:230px; ">
                    <div class="grid-content bg-purple-light orderTwo_content9">
                      <div class="sh_item sh_item3">
                        <div class="sh_map"></div>
                        <div class="sh_map2">
                          <div class="sh_map2_w1">{{item.pol}}</div>
                          <div class="sh_map2_w2">{{item.pod}}</div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="6" style="width: 180px;">
                    <div class="grid-content bg-purple orderTwo_content6">
                      <div class="sh_item sh_item2">
                        <div style="color: #333333;">{{item.totalDuration}}天</div>
                        <div v-if="item.isTransit==0" style="color: #3F3F3F;">直达</div>
                        <div v-else style="color: #3F3F3F;">中转/{{item.transitPortEn}}</div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="3" style="width: 190px;">
                    <div class="grid-content bg-purple-light orderTwo_content7">
                      <div class="sh_item sh_item2">{{item.eta}}</div>
                    </div>
                  </el-col>
                  <el-col :span="3" style="width: 60px;">
                    <div class="grid-content bg-purple-light orderTwo_content10">
                      <el-button
                        disabled
                        class="sh_enquiry"
                        type="primary"
                        plain
                        size="small"
                        @click="enquiryClick(item)"
                      >询价</el-button>
                    </div>
                    <div>
                      <el-button
                        class="sh_skip"
                        type="text"
                        style="text-decoration:underline"
                        @click="shSkip(item)"
                      >查看船舶计划</el-button>
                    </div>
                  </el-col>
                </el-row>
              </li>
            </ul>
          </el-main>
          <el-dialog
            custom-class="sh_header"
            title="完善询价信息"
            :visible.sync="enquiryShow"
            style="text-align: left;"
            top="20px"
            @close="closeDialog"
            width="660px"
          >
            <div v-show="perfect == 1 " class="sh_header_box">请完善询价信息</div>
            <el-form :model="enquiryForm" :rules="rules" ref="enquiryForm">
              <div class="sh_box">
                <div class="ship-font ship-font1">船期信息</div>
                <el-row style="padding: 15px 0 0 0;">
                  <el-col :span="8" class="ship-font">船公司：{{selectShipInfo.carriercd}}</el-col>
                  <el-col :span="8" class="ship-font">开航日：{{selectShipInfo.etd}}</el-col>
                  <el-col :span="8">
                    <div class="ship-font">
                      航程：
                      <span>{{selectShipInfo.totalDuration}}天</span>&nbsp;
                      <span v-if="selectShipInfo.isTransit==0">直达</span>
                      <span v-else>中转</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row style="padding: 15px 0 0 0;">
                  <el-col
                    :span="12"
                    class="ship-font"
                    style="text-align: left; position: relative;"
                  >
                    <div class="ship-font_md1">起运港：</div>
                    <div class="ship-font_md2">{{selectShipInfo.pol}}</div>
                  </el-col>
                  <el-col :span="12" class="ship-font" style="position: relative;">
                    <div class="ship-font_md1">目的港：</div>
                    <div class="ship-font_md2">{{selectShipInfo.pod}}</div>
                  </el-col>
                </el-row>
              </div>
              <div class="sh_box">
                <div class="ship-font ship-font1" style="margin-bottom: 10px;">询价人信息</div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="公司："
                      label-width="110px"
                      prop="enquiryCompany"
                      size="small"
                      style="margin-bottom: 15px;"
                    >
                      <el-input v-model="enquiryForm.enquiryCompany" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="联系人："
                      label-width="110px"
                      prop="enquiryContactor"
                      size="small"
                      style="margin-bottom: 15px;"
                    >
                      <el-input v-model="enquiryForm.enquiryContactor" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="联系人邮箱："
                      label-width="110px"
                      prop="enquiryExmail"
                      size="small"
                    >
                      <el-input v-model="enquiryForm.enquiryExmail" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系人电话：" label-width="110px" prop="enquiryTel" size="small">
                      <el-input v-model="enquiryForm.enquiryTel" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="sh_box2">
                <div class="ship-font ship-font1" style="margin-bottom: 10px;">运输信息</div>
                <el-row>
                  <el-col :span="14">
                    <el-form-item
                      class="xiangx"
                      required
                      :label="index==0?'数量/箱型：':''"
                      label-width="110px"
                      style="margin-bottom: 0;"
                      v-for="(boxItem,index) in enquiryForm.addForm"
                      :key="index"
                    >
                      <el-col :span="11">
                        <el-form-item
                          :prop="'addForm.'+index+'.quantity'"
                          size="small"
                          :rules="rules.quantity"
                        >
                          <el-input placeholder="数量" v-model="boxItem.quantity"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item
                          :prop="'addForm.'+index+'.boxPile'"
                          style="margin-left: 7px;"
                          size="small"
                          :rules="rules.boxPile"
                        >
                          <el-select
                            v-model="boxItem.boxPile"
                            @change="handleSelect"
                            clearable
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="(item,index) in boxType"
                              :key="index"
                              :value="item.boxTypeItem"
                              :disabled="item.setDisabled"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <i
                          class="ship-box-type"
                          :class="[{'el-icon-circle-plus ship-add-color':index==0 && enquiryForm.addForm.length<5},{'el-icon-remove ship-delete-color':index>0}]"
                          @click="addItem(index)"
                        ></i>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item
                      label="运输条款："
                      label-width="110px"
                      prop="selectClauseCode"
                      size="small"
                    >
                      <el-select
                        v-model="enquiryForm.selectClauseCode"
                        clearable
                        placeholder="请选择"
                        @change="yunshu"
                      >
                        <el-option
                          v-for="(item,index) in transportClause"
                          :key="index"
                          :label="item.clauseName"
                          :value="item.number"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="附加服务：" label-width="110px" prop="serviceType" size="mini">
                  <el-checkbox-group v-model="enquiryForm.serviceType">
                    <el-checkbox label="需要门点拖车"></el-checkbox>
                    <el-checkbox label="需要仓库内装"></el-checkbox>
                    <el-checkbox label="需要报关"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="货物描述："
                  label-width="110px"
                  prop="cargoDescription"
                  size="small"
                >
                  <el-input
                    type="textarea"
                    placeholder="100字以内"
                    v-model="enquiryForm.cargoDescription"
                  ></el-input>
                </el-form-item>
                <el-form-item label="备注：" label-width="110px" prop="note" size="small">
                  <el-input
                    type="textarea"
                    placeholder="300字以内"
                    rows="3"
                    v-model="enquiryForm.note"
                  ></el-input>
                </el-form-item>
              </div>

              <el-form-item style="text-align: center" size="small">
                <el-button
                  type="primary"
                  class="sh_enquirySubmit"
                  style="width: 30%;"
                  @click="enquirySubmit('enquiryForm')"
                  :disabled="disable"
                >提交</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
          <!-- 表单 -->

          <div class>
            <!-- :current-page.sync="pageNum" -->

            <el-pagination
              class="paging"
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              :total="totalCount"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    //询价联系人电话
    var checkEnquiryTel = (rule, value, callback) => {
      var regPhone = /^1[3456789]\d{9}$/; //手机号校验正则
      if (!value) {
        callback(new Error("请输入联系人电话"));
      } else if (!regPhone.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    //特殊字符正则
    var regCharater = new RegExp(
      "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"
    );
    //询价公司
    var checkEnquiryCompany = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入公司"));
      } else if (regCharater.test(value)) {
        callback(new Error("您输入的公司含有特殊字符"));
      } else if (value.length > 100) {
        callback(new Error("公司长度不能大于100"));
      } else {
        callback();
      }
    };
    //询价联系人
    var checkContactor = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入联系人"));
      } else if (regCharater.test(value)) {
        callback(new Error("您输入的联系人含有特殊字符"));
      } else if (value.length > 50) {
        callback(new Error("联系人长度不能大于50"));
      } else {
        callback();
      }
    };
    //询价邮箱
    var checkExmail = (rule, value, callback) => {
      //邮箱校验正则
      var regExmail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (!value) {
        callback(new Error("请输入联系人邮箱"));
      } else if (!regExmail.test(value)) {
        callback(new Error("邮箱格式有误，请输入正确邮箱"));
      } else {
        callback();
      }
    };
    //数量
    var checkBoxAmount = (rule, value, callback) => {
      var regb = /^[1-9]\d*$/; //正整数
      if (!value) {
        callback(new Error("请输入数量"));
      } else if (!regb.test(value)) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    };
    //箱型
    var checkBoxType = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择箱型"));
      } else {
        callback();
      }
    };
    //运输条款
    var checkClause = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择运输条款"));
      } else {
        callback();
      }
    };
    //货物描述
    var checkDescription = (rule, value, callback) => {
      if (value) {
        if (value.length > 100) {
          callback(new Error("货物描述长度不能大于100"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //备注
    var checkNote = (rule, value, callback) => {
      if (value) {
        if (value.length > 300) {
          callback(new Error("备注信息长度不能大于300"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      historys: "0",
      dataws: {
        ye: ""
      },
      sh_information: 0,
      perfect: "",
      hidden1: "0", //手写校验2
      hidden2: "0", //手写校验2
      loading: false,
      disable: false, //防止多次提交
      isCreate: "1", //销售线索
      months: "30", //一月有多少天
      Shipment: "20", //船期必传参数（写死）
      enquiryw: "30", //询价必传参数（写死）
      horizonCheckDate: "", //横向日期选中值
      enquiryShow: false, //询价弹窗
      selectShip: "", //选中的月份
      startPort: "", //起运港
      reachPort: "", //目的港
      dialogTableVisible: false, //船期日历弹窗
      selectDate: [], //选择日期
      dateArray: [], //七天日期数组
      divideDate1: [], //分割28天日期的第一份
      reachChecked: [], //选中的运输方式
      reachMode: ["直达", "中转"], //运输方式
      shipChecked: [], //选中的船公司
      shipCompany: [], //船公司数据
      shipList: "", //船期列表
      pageSize: 10, //每页条数
      pageNum: 1, //页码
      totalCount: 0, //总条数
      isTransit: "", //默认不选中，直达或中转标识
      startPortList: [], //起运港数据
      reachPortList: [], //目的港数据
      startPortCode: "", //起运港五字码
      reachPortCode: "", //目的港五字码
      shipDate28: [], //28天船期
      selectShipInfo: {}, //询价选择的船公司数据
      originPortCode: "", //起运港code
      destinationPortCode: "", //目的港code
      eta: "",
      boxType: [
        //箱型
        { boxTypeItem: "20GP" },
        { boxTypeItem: "20RF" },
        { boxTypeItem: "40GP" },
        { boxTypeItem: "40HC" },
        { boxTypeItem: "40HR" },
        { boxTypeItem: "20HC" },
        { boxTypeItem: "20HH" },
        { boxTypeItem: "20HT" },
        { boxTypeItem: "20HZ" },
        { boxTypeItem: "20OH" },
        { boxTypeItem: "20OL" },
        { boxTypeItem: "20OS" },
        { boxTypeItem: "20OT" },
        { boxTypeItem: "20OW" },
        { boxTypeItem: "20PC" },
        { boxTypeItem: "20RE" },
        { boxTypeItem: "20RH" },
        { boxTypeItem: "20SP" },
        { boxTypeItem: "20TK" },
        { boxTypeItem: "20WH" },
        { boxTypeItem: "22DO" },
        { boxTypeItem: "40BK" },
        { boxTypeItem: "40BO" },
        { boxTypeItem: "40FR" },
        { boxTypeItem: "40HH" },
        { boxTypeItem: "40HT" },
        { boxTypeItem: "40HZ" },
        { boxTypeItem: "40OH" },
        { boxTypeItem: "40OL" },
        { boxTypeItem: "40OS" },
        { boxTypeItem: "40OT" },
        { boxTypeItem: "40OW" },
        { boxTypeItem: "40PC" },
        { boxTypeItem: "40RE" },
        { boxTypeItem: "40RF" },
        { boxTypeItem: "40RH" },
        { boxTypeItem: "40SP" },
        { boxTypeItem: "40TK" },
        { boxTypeItem: "40WH" },
        { boxTypeItem: "43DO" },
        { boxTypeItem: "45BK" },
        { boxTypeItem: "45BO" },
        { boxTypeItem: "45FR" },
        { boxTypeItem: "45GP" },
        { boxTypeItem: "45HC" },
        { boxTypeItem: "45HH" },
        { boxTypeItem: "45HZ" },
        { boxTypeItem: "45OH" },
        { boxTypeItem: "45OL" },
        { boxTypeItem: "45OS" },
        { boxTypeItem: "45OT" },
        { boxTypeItem: "45OW" },
        { boxTypeItem: "45PC" },
        { boxTypeItem: "45RF" },
        { boxTypeItem: "45SP" },
        { boxTypeItem: "45TK" },
        { boxTypeItem: "45WH" },
        { boxTypeItem: "53RF" }
      ],
      transportClause: [
        //运输条款
        { clauseName: "DOOR/DOOR", number: "10" },
        { clauseName: "DOOR/CY", number: "20" },
        { clauseName: "DOOR/CFS", number: "30" },
        { clauseName: "CY/DOOR", number: "40" },
        { clauseName: "CY/CY", number: "50" },
        { clauseName: "CY/CFS", number: "60" },
        { clauseName: "CY/FO", number: "70" },
        { clauseName: "CY/RAMP", number: "80" },
        { clauseName: "CFS/RAMP", number: "90" },
        { clauseName: "CFS/CY", number: "100" },
        { clauseName: "CFS/CFS", number: "110" },
        { clauseName: "CFS/DOOR", number: "120" }
      ],
      enquiryForm: {
        enquiryCompany: "", //询价公司
        enquiryContactor: "", //询价联系人
        enquiryExmail: "", //询价邮箱
        enquiryTel: "", //询价电话
        selectClause: "", //选中的运输条款
        selectClauseCode: "", //选中的运输条款
        serviceType: [], //附加服务
        cargoDescription: "", //货物描述
        note: "", //备注
        addForm: [
          {
            quantity: "", //数量
            boxPile: "" //选中的箱型
          }
        ]
      },
      HistoryForm: [],
      rules: {
        enquiryCompany: [
          { required: true, validator: checkEnquiryCompany, trigger: "blur" }
        ],
        enquiryContactor: [
          { required: true, validator: checkContactor, trigger: "blur" }
        ],
        enquiryExmail: [
          { required: true, validator: checkExmail, trigger: "blur" }
        ],
        enquiryTel: [
          { required: true, validator: checkEnquiryTel, trigger: "blur" }
        ],
        quantity: [{ validator: checkBoxAmount, trigger: "blur" }],
        boxPile: [{ required: true, message: "请输入箱型", trigger: "change" }],
        selectClauseCode: [
          { required: true, validator: checkClause, trigger: "change" }
        ],
        cargoDescription: [{ validator: checkDescription, trigger: "blur" }],
        note: [{ validator: checkNote, trigger: "blur" }]
      }
    };
  },

  computed: {
    shipDate: {
      //获取当前船期
      get: function() {
        return this.formatDate(
          Date.parse(new Date()) + 4 * 24 * 60 * 60 * 1000,
          "yyyy-MM-dd"
        );
      }
    },
    //船期组件右箭头按钮
    rightBtn: {
      get: function() {
        if (this.dateArray.length > 0) {
          if (this.dateArray.length == 2) {
            return true;
          }
        }
      }
    },
    //船期组件左按钮
    leftBtn: {
      get: function() {
        if (this.dateArray.length > 0) {
          if (this.dateArray[0].mark == 1) {
            return true;
          }
        }
      }
    }
  },
  mounted() {
    let len = JSON.parse(localStorage.getItem("userInfo"));
    if (len) {
      this.history();
    } else {
      this.historys = 0;
    }
    this.currentDate();
    this.generateDate();
    this.developerDate();
    this.horizonCheckDate = this.formatDate(
      Date.parse(new Date()) + 4 * 24 * 60 * 60 * 1000,
      "yyyy-MM-dd"
    );
    this.selectShip = this.formatDate(
      Date.parse(new Date()) + 4 * 24 * 60 * 60 * 1000,
      "yyyy-MM"
    );
    //接收路由传的值
    if (this.$route.params.startItem) {
      this.startPortList.push(this.$route.params.startItem);
    }
    if (this.$route.params.reachItem) {
      this.reachPortList.push(this.$route.params.reachItem);
    }
    console.log(this.$route.params.startPortCode);
    this.startPort = this.$route.params.startPort; //起运港
    this.startPortCode = this.$route.params.startPortCode; //起运港五字码
    this.originPortCode = this.$route.params.originPortCode;
    this.destinationPortCode = this.$route.params.destinationPortCode;
    this.reachPort = this.$route.params.reachPort; //目的港
    this.reachPortCode = this.$route.params.reachPortCode; //目的港五字码
    if (this.startPortCode && this.startPortCode) {
      this.queryShipDate();
    }
  },
  methods: {
    //船舶计划跳转
    shSkip(e) {
      this.$router.push({
        name: "ShippingPlan",
        params: {
          vslNameEn: e.vessel,
          voyExport: e.voyage,
          polCode: e.polCode
        }
      });
    },
    yunshu(value) {
      var objItem = this.transportClause.find(item => {
        return item.number === value;
      });
      if (typeof objItem == "object") {
        this.selectClause = objItem.clauseName;
      } else {
        this.selectClause = "";
      }
    },
    //起运港选中值发生变化时触发
    getHandeleStart(value) {
      if (this.startPortList) {
        var objItem = this.startPortList.find(item => {
          return item.portCode === value;
        });
      }
      if (typeof objItem == "object") {
        this.startPort = objItem.portEn;
        this.originPortCode = objItem.portCode;
      } else {
        this.startPort = "";
      }
    },
    //目的港选中值发生变化时触发
    getHandeleReach(value) {
      if (this.reachPortList) {
        var objItem = this.reachPortList.find(item => {
          return item.portCode === value;
        });
      }
      if (typeof objItem == "object") {
        this.reachPort = objItem.portEn;
        this.destinationPortCode = objItem.portCode;
      } else {
        this.reachPort = "";
      }
    },
    // 监听起运港输入框的值
    remoteStart(value) {
      this.getPortData(value, "start");
    },
    // 监听目的港输入框的值
    remoteReach(value) {
      this.getPortData(value, "reach");
    },

    //查询船期按钮
    queryShipDate() {
      let that = this;
      let st = that.startPortCode;
      let rt = that.reachPortCode;
      if (!st && !rt) {
        that.hidden1 = "1";
        that.hidden2 = "1";
        setTimeout(function() {
          that.hidden1 = "0";
          that.hidden2 = "0";
        }, 3000);
        return false;
      } else if (st && !rt) {
        that.hidden1 = "0";
        that.hidden2 = "1";
        setTimeout(function() {
          that.hidden2 = "0";
        }, 3000);
      } else if (!st && rt) {
        that.hidden1 = "1";
        that.hidden2 = "0";
        setTimeout(function() {
          that.hidden1 = "0";
        }, 3000);
      } else if (st && rt) {
        let paramss = {
          startPortCode: this.startPortCode,
          startPort: this.startPort,
          reachPortCode: this.reachPortCode,
          reachPort: this.reachPort,
          startItem: this.startPortList,
          reachItem: this.reachPortList,
          originPortCode: this.originPortCode,
          destinationPortCode: this.destinationPortCode
        };
        localStorage.setItem("queryData", JSON.stringify(paramss));
        this.loading = true;
        this.postRequest();
      }
    },
    // 销售线索
    async clue(e) {
      let that = this;
      var getfo = JSON.parse(localStorage.getItem("userInfo"));
      let data = {};
      data.salesLeadsType = "VS";
      data.opsCustId = getfo.opsCustId;
      data.opsUserId = getfo.opsUserId;
      data.userDomainCode = "SSLCP";
      data.salesLeadsVesselSchedule = {};
      data.salesLeadsVesselSchedule.polName = that.startPort;
      data.salesLeadsVesselSchedule.polCode = that.startPortCode;
      data.salesLeadsVesselSchedule.podName = that.reachPort;
      data.salesLeadsVesselSchedule.podCode = that.reachPortCode;
      data.salesLeadsVesselSchedule.polEtd = that.horizonCheckDate;
      await that.apiService
        .post("/sinoslog-ops-service/salesLeads/salesLeadsRecord", data)
        .then(res => {});
    },
    async postRequest() {
      let that = this;
      let len = JSON.parse(localStorage.getItem("queryData"));
      let data = {};
      data.polCode = len.startPortCode;
      data.podCode = len.reachPortCode;
      data.etd = that.horizonCheckDate;
      data.weeksOut = "4";
      data.carriercd = that.shipChecked.join();
      data.isTransit = that.isTransit;
      data.pageNum = that.pageNum;
      data.pageSize = that.pageSize;
      await that.apiService
        .post("/sinoslog-ops-service/sailingDate/query", data)
        .then(res => {
          this.loading = false;
          this.clue();
          if (res.data) {
            that.sh_information = 1;
            that.shipList = res.data.data;
            that.shipCompany = []; //清空航运公司数据
            res.data.data.content.map(function(data) {
              if (that.shipCompany.indexOf(data.carriercd) == -1) {
                that.shipCompany.push(data.carriercd);
              }
            });
          } else {
            that.shipList = []; //清空船期数据
            that.shipCompany = []; //清空航运公司数据
            this.sh_information = 0;
            return false;
          }
        });
    },
    //起运港和目的港获取焦点事件
    getFocus(portType) {
      switch (portType) {
        case "start":
          this.getPortData(this.startPort, portType);
          break;
        case "reach":
          this.getPortData(this.reachPort, portType);
          break;
      }
    },
    //获取起运港和目的港港口数据
    async getPortData(val, type) {
      let that = this;
      let params = {};
      params.strKey = val;
      let response = await this.apiService
        .get("/sinoslog-common-service/mdPort/getMdPortInfo", { params })
        .then(res => {
          switch (type) {
            case "start":
              that.startPortList = res.data.data.records;
              break;
            case "reach":
              that.reachPortList = res.data.data.records;
              break;
          }
        });
    },
    //直达和中转checkbox变化事件
    reachModeChange(value) {
      switch (value.length) {
        case 0:
          this.isTransit = "";
          break;
        case 1:
          value[0] == "直达" ? (this.isTransit = "0") : (this.isTransit = "1");
          break;
        case 2:
          this.isTransit = "";
          break;
      }
      this.pageNum = 1; //重置查询的页码
      this.getShipData();
    },
    //航运公司checkbox变化事件
    checkShip(value) {
      this.pageNum = 1; //重置查询的页码
      this.shipChecked = value;
      this.getShipData();
    },
    //选中日期
    checkEtd(data) {
      let st = this.startPortCode;
      let rt = this.reachPortCode;

      this.horizonCheckDate = data.fullYear;
      this.dateArray = [];
      this.dateArray = this.shipDate28.filter(function(item) {
        return item.mark == data.mark;
      });
      this.dialogTableVisible = false;
      if (st && rt) {
        let len = JSON.parse(localStorage.getItem("queryData"));
        if (len) {
          this.getShipData();
        }
      } else {
        return false;
      }
    },

    //询价点击事件
    enquiryClick(data) {
      if (this.$cookies.get("username") && this.$cookies.get("password")) {
        this.eta = data.eta;
        //登录
        let len = JSON.parse(localStorage.getItem("userInfo"));

        let that = this;
        that
          .axios({
            method: "get",
            url: that.apiUrl + "/bnwl_user_business/sysUser/getSysUser",
            timeout: 60000,
            responseType: "json",
            params: {
              sysUserId: len.userId
            }
          })
          .then(res => {
            if (res.status === 200) {
              this.enquiryForm.enquiryExmail = res.data.sysUser.email;
              this.enquiryForm.enquiryTel = res.data.sysUser.mobilePhone;
              this.enquiryForm.enquiryContactor = res.data.sysUser.userNameCn;
              this.enquiryForm.enquiryCompany = res.data.sysUser.company;
            }
          });

        this.selectShipInfo = data;
        var str = this.selectShipInfo.etd;
        let tr = str.trim().split(" ")[0];
        this.selectShipInfo.etd = tr;

        this.enquiryShow = true;
      } else {
        //未登录
        this.$router.push({ name: "Login" });
      }
    },
    //关闭询价对话框
    closeDialog() {
      this.perfect = "";
      this.$refs["enquiryForm"].resetFields();
      this.enquiryForm.addForm = [
        {
          quantity: "",
          boxPile: ""
        }
      ];
      this.iterateBoxType();
    },
    //询价提交按钮
    // enquirySubmit(formName) {
    //   var that = this;
    //   that.$refs[formName].validate(valid => {
    //     this.perfect = 1;
    //     var getfo = JSON.parse(localStorage.getItem("userInfo"));
    //     var lents = JSON.parse(localStorage.getItem("queryData"));
    //     if (valid) {
    //       this.perfect = "";
    //       this.disable = true;
    //       that
    //         .axios({
    //           method: "post",
    //           url: that.apiUrl + "/bnwl_oms_business/enquiry/enquirySend",
    //           timeout: 60000,
    //           responseType: "json",
    //           data: {
    //             eta: that.getDateStringBy(this.eta),
    //             routeCode: that.selectShipInfo.routeCode,
    //             voyage: that.selectShipInfo.voyage,
    //             vessel: that.selectShipInfo.vessel,
    //             customerCode: getfo.customerCode,
    //             clewType: that.enquiryw,
    //             shippingCompany: that.selectShipInfo.carriercd,
    //             originPort: that.selectShipInfo.pol,
    //             destinationPort: that.selectShipInfo.pod,
    //             sailingDate: that.getDateStringBy(that.selectShipInfo.etd),
    //             range: that.selectShipInfo.totalDuration,
    //             directTransfer:
    //               that.selectShipInfo.isTransit == 0 ? "直达" : "中转",
    //             specialRequirements: "无",
    //             company: that.enquiryForm.enquiryCompany,
    //             enquiryName: that.enquiryForm.enquiryContactor,
    //             mail: that.enquiryForm.enquiryExmail,
    //             phone: that.enquiryForm.enquiryTel,
    //             qantityBoxpiles: that.enquiryForm.addForm,
    //             freightTerm: that.selectClause,
    //             selectClauseCode: that.enquiryForm.selectClauseCode,
    //             accessorialService: that.enquiryForm.serviceType.join(","),
    //             cargoDescribe: that.enquiryForm.cargoDescription,
    //             remark: that.enquiryForm.note,
    //             originPortCode: lents.startPortCode,
    //             destinationPortCode: lents.reachPortCode,
    //             userNameCode: JSON.parse(localStorage.getItem("userInfo"))
    //               .username
    //           }
    //         })
    //         .then(res => {
    //           if (res.data.data.code == "OKY" && res.data.data) {
    //             that.enquiryShow = false;
    //             this.disable = false;
    //             that.$msgbox({
    //               title: "",
    //               message:
    //                 "<div>询价信息已提交</div><div>业务人员将在12小时内与您联系</div>",
    //               closeOnHashChange: true,
    //               center: true,
    //               dangerouslyUseHTMLString: true,
    //               showClose: true,
    //               showConfirmButton: false
    //             });
    //           } else {
    //             that.$message({
    //               showClose: true,
    //               customClass: "register-bg",
    //               message: "发送邮件失败",
    //               type: "error",
    //               offset: 300
    //             });
    //           }
    //         });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    //添加或移除(数量/箱型)
    addItem(val) {
      if (val == 0) {
        if (this.enquiryForm.addForm.length < 5) {
          this.enquiryForm.addForm.push({
            quantity: "",
            boxPile: ""
          });
        }
      } else {
        this.enquiryForm.addForm.splice(val, 1);
      }
      this.iterateBoxType(); //移除或添加防止状态不变
    },
    //选择箱型值变化
    handleSelect(val) {
      this.iterateBoxType();
    },
    //遍历箱型
    iterateBoxType() {
      var self = this;
      self.boxType.map(function(temp) {
        temp.setDisabled = false;
        self.enquiryForm.addForm.map(function(item) {
          if (item.boxPile) {
            if (item.boxPile == temp.boxTypeItem) {
              temp.setDisabled = true;
            }
          }
        });
      });
    },
    //生成选择日期数组
    developerDate() {
      this.selectDate = []; //置空数组，防止脏数据
      if (this.divideDate1.length > 0) {
        var index1 = this.divideDate1.length - 1;
        this.selectDate.push({
          selected:
            this.divideDate1[index1].year + "-" + this.divideDate1[index1].month
        });
      }
    },
    //获取当前日期推算的七天日期
    currentDate() {
      //生成28天，并标记所属的7天
      for (var s = 0; s < this.months; s++) {
        var currentTamp = Date.parse(new Date()) + 4 * 24 * 60 * 60 * 1000; //当前时间戳
        var dateObj = currentTamp + s * 24 * 60 * 60 * 1000;
        var week = "周" + "日一二三四五六".charAt(new Date(dateObj).getDay());
        this.shipDate28.push({
          year: this.formatDate(dateObj, "yyyy"),
          month: this.formatDate(dateObj, "MM"),
          fullYear: this.formatDate(dateObj, "yyyy-MM-dd"),
          yueRi: this.formatDate(dateObj, "MM-dd"),
          weekDay: week,
          mark: parseInt(s / 7) + 1
        });
      }

      //取出默认七天的值
      this.dateArray = this.shipDate28.filter(function(item) {
        return item.mark == 1;
      });
    },
    //格式化日期方法
    formatDate(date, format) {
      let $this = new Date(date);
      let o = {
        "M+": $this.getMonth() + 1,
        "d+": $this.getDate(),
        "h+": $this.getHours(),
        "m+": $this.getMinutes(),
        "s+": $this.getSeconds(),
        "q+": Math.floor(($this.getMonth() + 3) / 3),
        S: $this.getMilliseconds()
      };
      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          ($this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    //格式化yyyy-MM-dd hh:mm:ss为date日期格式
    getDateStringBy(dateStr) {
      if (dateStr) {
        var regEx = new RegExp("\\-", "gi");
        dateStr = dateStr.replace(regEx, "/");
        var retDate = new Date(dateStr);
        return retDate;
      }
    },
    //往后推7天日期事件
    minusSeven(baseTime) {
      this.dateArray = []; //清空数组
      this.dateArray = this.shipDate28.filter(function(data) {
        return data.mark == baseTime - 1;
      });
    },
    //往前推7天日期事件
    plusSeven(baseTime) {
      this.dateArray = []; //清空数组
      this.dateArray = this.shipDate28.filter(data => {
        return data.mark == baseTime + 1;
      });
    },
    //打开日历
    openCalendar(e) {
      var eses = this.formatDate(Date.parse(new Date()), "yyyy-MM-dd hh:mm:ss");

      this.dataws.ye = eses;

      this.dialogTableVisible = true;
    },
    //更多日期数据,生成28天
    generateDate() {
      this.divideDate1 = [];
      for (var i = 0; i < this.shipDate28.length; i++) {
        var year = new Date().getFullYear(); //当前年
        var month = this.formatDate(
          Date.parse(new Date()) + 4 * 24 * 60 * 60 * 1000,
          "MM"
        ); //当前月
        // new Date().getMonth() + 1;
        //判断是否跨年
        if (this.shipDate28[i].year == year) {
          //不跨年
          //判断是否跨月
          this.divideDate1.push(this.shipDate28[i]);
        } else {
          //跨年
          this.divideDate1.push(this.shipDate28[i]);
        }
      }
      if (this.divideDate1.length > 0) {
        this.fillCalendar(this.divideDate1, this.divideDate1[0].weekDay);
      } else {
        this.fillCalendar(this.divideDate1, this.divideDate1[0].weekDay);
      }
    },
    /**
     * @params:
     * 参数1：传入的数组
     * 参数2：传入的参数周几
     * */
    fillCalendar(array, week) {
      var s = 0;
      switch (week) {
        case "周一":
          while (s < 1) {
            this.addElement(array);
            s++;
          }
          break;
        case "周二":
          while (s < 2) {
            this.addElement(array);
            s++;
          }
          break;
        case "周三":
          while (s < 3) {
            this.addElement(array);
            s++;
          }
          break;
        case "周四":
          while (s < 4) {
            this.addElement(array);
            s++;
          }
          break;
        case "周五":
          while (s < 5) {
            this.addElement(array);
            s++;
          }
          break;
        case "周六":
          while (s < 6) {
            this.addElement(array);
            s++;
          }
          break;
        case "周日":
          break;
      }
    },
    /**
     * @params:
     * 数组指定位置添加元素
     * 参数:数组
     * */
    addElement(a) {
      a.splice(0, 0, {
        fullYear: "",
        yueRi: "",
        weekDay: ""
      });
    },
    //获取船期列表数据
    getShipData() {
      var that = this;
      let st = that.startPortCode;
      let rt = that.reachPortCode;
      let len = JSON.parse(localStorage.getItem("queryData"));
      if (!st && !rt) {
        localStorage.removeItem("queryData");
        return false;
      } else {
        this.loading = true;
        this.postRequest();
      }
    },
    //currentPage 改变触发事件
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.getShipData();
    },

    // 获取历史记录
    async history() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      var that = this;
      let params = {};
      params.opsUserId = len.opsUserId;
      params.salesLeadsType = "VS";
      let response = await this.apiService
        .get("/sinoslog-ops-service/salesLeads/userSearchHistory", {
          params
        })
        .then(res => {
          if (res.data.data) {
            if (res.data.data.length) {
              this.historys = 1;
              this.HistoryForm = res.data.data;
            } else {
              this.historys = 0;
              return false;
            }
          } else {
            this.historys = 0;
            return false;
          }
        });
    },
    //历史记录点击

    historyClick(e) {
      this.startPortCode = e.polName;
      this.reachPortCode = e.podName;
      let that = this;
      var paramss = {
        startPortCode: e.polCode,
        startPort: e.polName,
        reachPortCode: e.podCode,
        reachPort: e.podName,
        startItem: this.startPortList,
        reachItem: this.reachPortList,
        originPortCode: this.originPortCode,
        destinationPortCode: this.destinationPortCode
      };
      localStorage.setItem("queryData", JSON.stringify(paramss));
      this.loading = true;
      let data = {};
      data.polCode = e.polCode;
      data.podCode = e.podCode;
      data.etd = that.horizonCheckDate;
      data.weeksOut = "4";
      data.carriercd = that.shipChecked.join();
      data.isTransit = that.isTransit;
      data.pageNum = that.pageNum;
      data.pageSize = that.pageSize;
      that.apiService
        .post("/sinoslog-ops-service/sailingDate/query", data)
        .then(res => {
          this.loading = false;
          this.clue();
          if (res.data) {
            that.sh_information = 1;
            that.shipList = res.data.data;
            that.shipCompany = []; //清空航运公司数据
            res.data.data.content.map(function(data) {
              if (that.shipCompany.indexOf(data.carriercd) == -1) {
                that.shipCompany.push(data.carriercd);
              }
            });
          } else {
            that.shipList = []; //清空船期数据
            that.shipCompany = []; //清空航运公司数据
            this.sh_information = 0;
            return false;
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.home-port1
  > .el-input
  > .el-input__suffix
  > .el-input__suffix-inner
  > .el-input__icon {
  line-height: 45px !important;
}
.ShipSchedule_box {
  width: 1200px !important;
  margin: 0 auto !important;
}
.ship-line {
  background-image: url("../assets/img/azimuth.png");
  background-repeat: no-repeat;
  background-size: contain;
  padding: 22px 5px;
}

.date-selected-active {
  text-align: center;
  background-color: #539dfe;
  border-radius: 12px;
  color: #fff;
  padding: 4px 5px;
  margin: 0 4px;
}

.date-selected {
  text-align: center;
  background-color: #fff;
  border-radius: 12px;
  color: #606266;
  padding: 4px 5px;
  margin: 0 4px;
}

.ship-font {
  font-size: 14px;
}

.ship-font1 {
  color: #333;
  font-weight: bold;
}

.ship-shadow {
  -webkit-box-shadow: 0px 1px 3px #888888;
  -moz-box-shadow: 0px 1px 3px #888888;
  -o-box-shadow: 0px 1px 3px #888888;
  box-shadow: 0px 1px 3px #888888;
  /* border: 1px solid #eaeaea; */
}

.ship-radius {
  border-radius: 4px;
}

.ship-radius1 {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.ship-radius2 {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ship-port input {
  border-color: #fff;
  border-radius: 0;
}

.ship-border {
  color: #1b1464;
  border-bottom: 2px solid #1b1464;
  font-weight: 700;
}

.ship-list-bg {
  background-color: #fff;
  line-height: 42px;
  text-align: left;
  margin-top: 10px;
}

.ship-pointer {
  pointer-events: none;
}

.ship-box-type {
  font-size: 23px;
  padding: 0 10px;
}

.ship-add-color {
  color: #00418e;
}
.ship-add-color:hover {
  color: #66b1ff;
}
.ship-delete-color:hover {
  color: #66b1ff;
}

.ship-delete-color {
  color: red;
}
.ShipSchedule_box .el-input.is-disabled .el-input__inner {
  color: #a0a0a0 !important;
}

.Cl_hl {
  font-size: 15px;
}
.gaoL:hover {
  background-color: #eeecff;
  color: #1b1464;
  border-bottom: 2px solid #1b1464;
}
.gaoL2:hover {
  background-color: #eeecff;
  color: #1b1464;
}
.sh-calendar > .el-dialog > .el-dialog__header {
  border-bottom: 1px solid #dce6eb;
  padding: 20px 30px 10px;
}
.sh-calendar > .el-dialog > .el-dialog__header > .el-dialog__title {
  font-family: "SourceHanSans-Medium";
  color: #00418e;
}
.grey-bg {
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/views/ShipSchedule.vue